module.exports = __webpack_public_path__ + "img/grey-cardinal-2.493e66dc.svg";